'use client'

import { useMediaQuery } from '@mantine/hooks'
import { nebecaTabList } from './_const'
import CardApplication from './components/CardApplication'
import { useRouter } from 'next/navigation'

const NebecaPage = () => {
  const isMobile = useMediaQuery('(max-width:768px)')
  const router = useRouter()
  const onClickTab = (id: string) => {
    return id === 'apply' ? router.push('/nebeca/') : router.push(`/nebeca/${id}`)
  }
  return (
    <main className="relative mx-auto w-full min-w-[360px] max-w-[720px]">
      {!isMobile && (
        <h2 className="mb-2.5 text-center text-4xl font-bold md:mt-16">내일배움카드 신청 가이드</h2>
      )}
      <ul className="sticky left-0 top-0 z-10 flex w-full items-center justify-center gap-3 bg-white py-3 drop-shadow-[0_4px_4px_rgba(201,210,219,0.25)] md:drop-shadow-none">
        {nebecaTabList.map(tabItem => (
          <li
            className={`${tabItem.id === 'apply' ? 'bg-[#1E1E1E] text-white' : 'bg-gray-100 text-gray-400'} cursor-pointer rounded-lg p-2 text-sm font-semibold md:rounded-full md:px-3 md:py-1 md:text-base`}
            key={tabItem.id}
            onClick={() => onClickTab(tabItem.id)}
          >
            {tabItem.label}
          </li>
        ))}
      </ul>
      <CardApplication />
    </main>
  )
}

export default NebecaPage
